// var urlString = "http://localhost:8033/api-grub/";
// var urlString = "http://localhost:3021/ariha-foods-api/";
var urlString = "https://api.bechofy.in/ariha-foods-api/";
// var urlString = "https://api.grubdigest.com/api-grub/";
const GetApiCall = {
  getRequest(url) {
    return fetch(urlString + url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        schema: "ariha_foods",
        'x-auth-token': localStorage.getItem('access')
      },
    })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("request failed", error);
        return error;
      });
  },
};

export default GetApiCall;
